import { Box, FormControl, Stack, TextField, Typography } from '@mui/material'
import React from 'react'
import { Controller, useFormContext, useWatch } from 'react-hook-form'

import { ObservabilityToolHeaders } from 'components/status-checks/form/authentication/ObservabilityToolHeaders'
import { ObservabilityToolPrivateNetworkIntegration } from 'components/status-checks/form/authentication/ObservabilityToolPrivateNetworkIntegration'
import { type StatusCheckFormValues } from 'components/status-checks/status-checks-form-utils'
import { useObservabilityToolAuthenticationContext } from 'context/status-checks/ObservabilityToolAuthenticationContext'
import { ObservabilityToolType } from 'types/api/status-checks/status-check'

export const ObservabilityToolOtherAuthenticationDetails: React.FC = () => {
  const { control } = useFormContext<StatusCheckFormValues>()
  const { isEdit } = useObservabilityToolAuthenticationContext()

  const observabilityToolType = useWatch<StatusCheckFormValues>({
    control,
    name: 'observabilityTool.type'
  })

  const hasPrivateNetworkIntegrationOption =
    observabilityToolType === ObservabilityToolType.GRAFANA ||
    observabilityToolType === ObservabilityToolType.DYNATRACE

  return (
    <>
      <FormControl>
        {/* Using the Controller wrapper here because this value will be dynamically updated as other form values are selected */}
        <Controller
          control={control}
          name="apiBaseUrl"
          render={({ field, fieldState: { error } }) => (
            <TextField
              {...field}
              data-testid="observability-tool-authentication-api-base-url-input"
              disabled={isEdit}
              error={Boolean(error)}
              helperText={error?.message}
              label="API Base URL"
              variant="outlined"
            />
          )}
        />
      </FormControl>
      {hasPrivateNetworkIntegrationOption && (
        <Box sx={{ mt: 2 }}>
          <ObservabilityToolPrivateNetworkIntegration />
        </Box>
      )}
      <Stack spacing={2} sx={{ mt: 4 }}>
        <Typography variant="h6">Authentication</Typography>
        <Typography>
          What are the authentication key and header values Gremlin should use
          to authenticate this observability tool?
        </Typography>
        <ObservabilityToolHeaders isCustomObservabilityTool={false} />
      </Stack>
    </>
  )
}
